import { Project } from '../types/project';
import { projects } from '../data/projects';

export const useProjectStore = () => ({
  projects,
});